import { render, staticRenderFns } from "./InstruksiKhususPimpinanAdmin.vue?vue&type=template&id=11cda58c&scoped=true&lang=html&"
import script from "./InstruksiKhususPimpinanAdmin.vue?vue&type=script&lang=js&"
export * from "./InstruksiKhususPimpinanAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11cda58c",
  null
  
)

export default component.exports